import auth from "../auth/actions.js";
import fileDownload from "js-file-download";
import moment from "moment";

// If a "blob" response is actually a small JSON error payload, return it
// parsed; otherwise indicate the blob is binary and safe to save.
async function probeBlobForJson(blob) {
  if (!blob) return { isJson: false };
  // Real spreadsheet blobs are usually well over 1KB; cap at 8KB to be safe.
  if (typeof blob.size === "number" && blob.size > 8192) return { isJson: false };
  if (blob.type && blob.type.includes("application/json")) {
    try {
      const text = await blob.text();
      return { isJson: true, payload: JSON.parse(text) };
    } catch {
      return { isJson: false };
    }
  }
  // Fall back to sniffing the first bytes — text-like blobs may have no type.
  try {
    const text = await blob.text();
    const trimmed = text.trim();
    if (trimmed.startsWith("{") || trimmed.startsWith("[")) {
      try {
        return { isJson: true, payload: JSON.parse(trimmed) };
      } catch {
        // Not actually JSON.
      }
    }
  } catch {
    // Not text-readable.
  }
  return { isJson: false };
}

export default {
  state() {
    return {};
  },
  actions: {
    async GetCallReports(_, payload) {
      var params =
        "callType=" +
        payload.callType +
        "&agent=" +
        payload.agent +
        "&hungupparty=" +
        payload.hungparty +
        "&number=" +
        payload.number +
        "&duration=" +
        payload.duration +
        (payload.skill && payload.skill !== 0 && payload.skill !== "0" ? "&skill=" + payload.skill : "") +
        "&from=" +
        payload.from +
        "&to=" +
        payload.to +
        "&offset=" +
        payload.offset +
        "&limit=" +
        payload.limit +
        "&iscount=" +
        payload.iscount +
        "&export=" +
        payload.export;
      var headers = { request: "CallsReport" };
      var response;
      if (payload.export) {
        response = await auth.middleware.get("/CallsReport?" + params, {
          headers: headers,
          responseType: "blob",
        });
      } else {
        response = await auth.middleware.get("/CallsReport?" + params, {
          headers: headers,
        });
      }
      const responseData = response.data;
      if (response.status !== 200) {
        return { success: responseData.success, message: responseData.message };
        //   const error = new Error(responseData.message || "Failed to get users");
        //   throw error;
      }

      //
      if (!payload.export) {
        return {
          success: responseData.success,
          message: responseData.message,
          calls: responseData.result.calls,
          count: responseData.result.count,
        };
      } else {
        var filename = "calls_report_" + moment().unix() + ".csv";
        fileDownload(responseData, filename, "text/csv;charset=utf-8", "\uFEFF");
        return { success: true, exported: true };
      }
    },
    //GetPerformanceByPeriod
    async GetPerformanceByPeriod(_, payload) {
      var params =
        "skill=" +
        payload.skill +
        "&period=" +
        (payload.period || 3) + // Default to 3 (half hours)
        "&from=" +
        payload.from +
        "&to=" +
        payload.to +
        "&export=" +
        payload.export;

      const response = await auth.middleware.get(
        "/PerformanceByPeriodReport?" + params,
        {
          headers: { request: "PerformanceByPeriodReport" },
        }
      );

      const responseData = response.data;
      if (response.status !== 200) {
        return { success: responseData.success, message: responseData.message };
        //   const error = new Error(responseData.message || "Failed to get users");
        //   throw error;
      }
      //
      if (!payload.export) {
        return {
          success: responseData.success,
          message: responseData.message,
          periods: responseData.result.periods || [],
          total: responseData.result.total || null,
        };
      } else {
        var filename = "periods_report_" + moment().unix() + ".csv";
        fileDownload(responseData, filename, "text/csv;charset=utf-8", "\uFEFF");
        return { success: true, exported: true };
      }
    },
    async GetTotalPerformance(_, payload) {
      var params =
        "&from=" +
        payload.from +
        "&to=" +
        payload.to +
        "&export=" +
        payload.export;

      const response = await auth.middleware.get(
        "/TotalPerformanceReport?" + params,
        {
          headers: { request: "TotalPerformanceReport" },
        }
      );

      const responseData = response.data;
      if (response.status !== 200) {
        return { success: responseData.success, message: responseData.message };
        //   const error = new Error(responseData.message || "Failed to get users");
        //   throw error;
      }
      //
      if (!payload.export) {
        return {
          success: responseData.success,
          message: responseData.message,
          records: responseData.result.records,
        };
      } else {
        var filename = "total_performance_report" + moment().unix() + ".csv";
        fileDownload(responseData, filename, "text/csv;charset=utf-8", "\uFEFF");
        return { success: true, exported: true };
      }
    },
    async GetSystemInbound(_, payload) {
      var params =
        "skill=" +
        payload.skill +
        "&from=" +
        payload.from +
        "&to=" +
        payload.to +
        "&offset=" +
        payload.offset +
        "&limit=" +
        payload.limit +
        "&iscount=" +
        payload.iscount +
        "&export=" +
        payload.export;
      console.log(params);
      const response = await auth.middleware.get(
        "/SystemInboundReport?" + params,
        {
          headers: { request: "SystemInboundReport" },
        }
      );

      const responseData = response.data;
      if (response.status !== 200) {
        return { success: responseData.success, message: responseData.message };
        //   const error = new Error(responseData.message || "Failed to get users");
        //   throw error;
      }
      //
      if (!payload.export) {
        return {
          success: responseData.success,
          message: responseData.message,
          records: responseData.result.records,
          count: responseData.result.count,
        };
      } else {
        var filename = "system_inbound_report" + moment().unix() + ".csv";
        fileDownload(responseData, filename, "text/csv;charset=utf-8", "\uFEFF");
        return { success: true, exported: true };
      }
    },
    async GetRepeatedCallsReport(_, payload) {
      var params =
        "from=" +
        payload.from +
        "&to=" +
        payload.to;

      // Only add export flag when exporting
      if (payload.export) {
        params += "&export=1";
      }

      const headers = { request: "RepeatedCallsReport" };
      let response;

      if (payload.export) {
        response = await auth.middleware.get("/RepeatedCallsReport?" + params, {
          headers: headers,
          responseType: "blob",
        });
      } else {
        response = await auth.middleware.get("/RepeatedCallsReport?" + params, {
          headers: headers,
        });
      }

      const responseData = response.data;
      if (response.status !== 200) {
        return { success: responseData.success, message: responseData.message };
      }

      if (!payload.export) {
        // Normalize the API shape (result.calls -> flat records)
        let records = [];
        let totalCount = 0;

        if (Array.isArray(responseData.result?.calls)) {
          responseData.result.calls.forEach((monthBlock) => {
            const monthLabel = monthBlock.month || monthBlock.day || "Unknown";
            const daysObj = monthBlock.days || {};

            Object.entries(daysObj).forEach(([dayKey, entries]) => {
              (entries || []).forEach((entry) => {
                const repeated = entry.count || entry.repeated_calls || 0;
                records.push({
                  month: monthLabel,
                  day: dayKey,
                  phone_number: entry.number,
                  repeated_calls: repeated,
                });
                totalCount += repeated;
              });
            });
          });
        } else {
          records =
            responseData.result?.records ||
            responseData.records ||
            responseData.result ||
            [];
          if (Array.isArray(records)) {
            totalCount =
              responseData.result?.count ||
              responseData.count ||
              records.reduce(
                (sum, item) =>
                  sum + (item.repeated_calls || item.repeatedCalls || 0),
                0
              );
          }
        }

        const count =
          responseData.result?.count ||
          responseData.count ||
          (totalCount > 0 ? totalCount : records.length);

        return {
          success: responseData.success,
          message: responseData.message,
          records: records,
          count: count,
        };
      } else {
        var filename = "repeated_calls_report_" + moment().unix() + ".csv";
        fileDownload(responseData, filename, "text/csv;charset=utf-8", "\uFEFF");
        return { success: true, exported: true };
      }
    },
    async GetAgentPerformance(_, payload) {
      var params =
        "agent=" +
        payload.agent +
        "&agentStatus=" +
        payload.agentStatus +
        "&from=" +
        payload.from +
        "&to=" +
        payload.to +
        "&export=" +
        payload.export;

      const response = await auth.middleware.get(
        "/AgentPerformanceReport?" + params,
        {
          headers: { request: "AgentPerformanceReport" },
        }
      );

      const responseData = response.data;
      if (response.status !== 200) {
        return { success: responseData.success, message: responseData.message };
        //   const error = new Error(responseData.message || "Failed to get users");
        //   throw error;
      }
      //
      if (!payload.export) {
        return {
          success: responseData.success,
          message: responseData.message,
          records: responseData.result.records,
        };
      } else {
        var filename = "agent_performace_report_" + moment().unix() + ".csv";
        fileDownload(responseData, filename, "text/csv;charset=utf-8", "\uFEFF");
        return { success: true, exported: true };
      }
    },
    async GetAgentCalls(_, payload) {
      var params =
        "callType=" +
        payload.callType +
        "&number=" +
        payload.number +
        "&from=" +
        payload.from +
        "&to=" +
        payload.to +
        "&offset=" +
        payload.offset +
        "&limit=" +
        payload.limit +
        "&iscount=" +
        payload.iscount +
        "&export=" +
        payload.export;

      const response = await auth.middleware.get(
        "/AgentCallsReport?" + params,
        {
          headers: { request: "AgentCallsReport" },
        }
      );

      const responseData = response.data;
      if (response.status !== 200) {
        return { success: responseData.success, message: responseData.message };
        //   const error = new Error(responseData.message || "Failed to get users");
        //   throw error;
      }
      //
      if (!payload.export) {
        return {
          success: responseData.success,
          message: responseData.message,
          calls: responseData.result.calls,
          count: responseData.result.count,
        };
      } else {
        var filename = "my_calls_report_" + moment().unix() + ".csv";
        fileDownload(responseData, filename, "text/csv;charset=utf-8", "\uFEFF");
        return { success: true, exported: true };
      }
    },
    async GetAgentStatusReport(_, payload) {
      var params =
        "from=" +
        payload.from +
        "&to=" +
        payload.to +
        "&offset=" +
        payload.offset +
        "&limit=" +
        payload.limit +
        "&iscount=" +
        payload.iscount +
        "&export=" +
        payload.export;

      const response = await auth.middleware.get(
        "/AgentStatusReport?" + params,
        {
          headers: { request: "AgentStatusReport" },
        }
      );

      const responseData = response.data;
      if (response.status !== 200) {
        return { success: responseData.success, message: responseData.message };
        //   const error = new Error(responseData.message || "Failed to get users");
        //   throw error;
      }
      //
      if (!payload.export) {
        return {
          success: responseData.success,
          message: responseData.message,
          records: responseData.result.records,
          count: responseData.result.count,
          summary: responseData.result.summary,
        };
      } else {
        var filename = "my_status_report_" + moment().unix() + ".csv";
        fileDownload(responseData, filename, "text/csv;charset=utf-8", "\uFEFF");
        return { success: true, exported: true };
      }
    },
    //GetAgentLastCalls
    async GetAgentLastCalls(_, payload) {
      var limit = 5;
      if (!payload) {
        payload = limit;
      }
      const response = await auth.middleware.get(
        "/AgentLastCalls?limit=" + payload,
        {
          headers: { request: "AgentLastCalls" },
        }
      );

      const responseData = response.data;
      if (response.status !== 200) {
        return { success: responseData.success, message: responseData.message };
        //   const error = new Error(responseData.message || "Failed to get users");
        //   throw error;
      }
      //

      return {
        success: responseData.success,
        message: responseData.message,
        lastCalls: responseData.result.lastCalls,
      };
    },
    async GetAgentSummary() {
      var params =
        "from=" +
        moment().startOf("day").format("YYYY-MM-DD HH:mm:ss") +
        "&to=" +
        moment().endOf("day").format("YYYY-MM-DD HH:mm:ss");

      const response = await auth.middleware.get("/AgentSummary?" + params, {
        headers: { request: "AgentSummary" },
      });

      const responseData = response.data;
      if (response.status !== 200) {
        return { success: responseData.success, message: responseData.message };
        //   const error = new Error(responseData.message || "Failed to get users");
        //   throw error;
      }
      //

      return {
        success: responseData.success,
        message: responseData.message,
        summary: responseData.result,
      };
    },
    async GetLeavingDetails(_, payload) {
      console.log("Payload: ", payload);
      var params =
        "uname=" +
        payload.agent +
        "&from=" +
        payload.from +
        "&to=" +
        payload.to +
        "&offset=" +
        payload.offset +
        "&limit=" +
        payload.limit +
        "&iscount=" +
        payload.iscount +
        "&export=" +
        payload.export;

      const response = await auth.middleware.get(
        "/LeavingRequestReport?" + params,
        {
          headers: { request: "LeavingRequestReport" },
        }
      );

      const responseData = response.data;
      if (response.status !== 200) {
        return { success: responseData.success, message: responseData.message };
        //   const error = new Error(responseData.message || "Failed to get users");
        //   throw error;
      }
      //
      if (!payload.export) {
        return {
          success: responseData.success,
          message: responseData.message,
          records: responseData.result.records,
          count: responseData.result.count,
        };
      } else {
        var filename = "agent_performace_report_" + moment().unix() + ".csv";
        fileDownload(responseData, filename, "text/csv;charset=utf-8", "\uFEFF");
        return { success: true, exported: true };
      }
    },
    async GetLeavingSummary(_, payload) {
      var params =
        "uname=" +
        payload.agent +
        "&from=" +
        payload.from +
        "&to=" +
        payload.to +
        "&offset=" +
        payload.offset +
        "&limit=" +
        payload.limit +
        "&iscount=" +
        payload.iscount +
        "&export=" +
        payload.export;

      const response = await auth.middleware.get(
        "/LeavingRequestSummaryReport?" + params,
        {
          headers: { request: "LeavingRequestSummaryReport" },
        }
      );

      const responseData = response.data;
      if (response.status !== 200) {
        return { success: responseData.success, message: responseData.message };
        //   const error = new Error(responseData.message || "Failed to get users");
        //   throw error;
      }
      //
      if (!payload.export) {
        return {
          success: responseData.success,
          message: responseData.message,
          records: responseData.result.records,
          count: responseData.result.count,
        };
      } else {
        var filename = "leaving_report_summary_" + moment().unix() + ".csv";
        fileDownload(responseData, filename, "text/csv;charset=utf-8", "\uFEFF");
        return { success: true, exported: true };
      }
    },
    async GetLoginDetails(_, payload) {
      var params =
        "uname=" +
        payload.agent +
        "&from=" +
        payload.from +
        "&to=" +
        payload.to +
        "&offset=" +
        payload.offset +
        "&limit=" +
        payload.limit +
        "&iscount=" +
        payload.iscount +
        "&export=" +
        payload.export;

      const response = await auth.middleware.get("/LoginReport?" + params, {
        headers: { request: "LoginReport" },
      });

      const responseData = response.data;
      if (response.status !== 200) {
        return { success: responseData.success, message: responseData.message };
        //   const error = new Error(responseData.message || "Failed to get users");
        //   throw error;
      }
      //
      if (!payload.export) {
        return {
          success: responseData.success,
          message: responseData.message,
          records: responseData.result.records,
          count: responseData.result.count,
        };
      } else {
        var filename = "login_report_" + moment().unix() + ".csv";
        fileDownload(responseData, filename, "text/csv;charset=utf-8", "\uFEFF");
        return { success: true, exported: true };
      }
    },
    async GetLoginSummary(_, payload) {
      console.log("The Payload: ", payload);
      var params =
        "uname=" +
        payload.agent +
        "&from=" +
        payload.from +
        "&to=" +
        payload.to +
        "&offset=" +
        payload.offset +
        "&limit=" +
        payload.limit +
        "&iscount=" +
        payload.iscount +
        "&export=" +
        payload.export;

      const response = await auth.middleware.get(
        "/LoginSummaryReport?" + params,
        {
          headers: { request: "LoginSummaryReport" },
        }
      );

      const responseData = response.data;
      if (response.status !== 200) {
        return { success: responseData.success, message: responseData.message };
        //   const error = new Error(responseData.message || "Failed to get users");
        //   throw error;
      }
      //
      if (!payload.export) {
        return {
          success: responseData.success,
          message: responseData.message,
          records: responseData.result.records,
          count: responseData.result.count,
        };
      } else {
        var filename = "login_summary_report_" + moment().unix() + ".csv";
        fileDownload(responseData, filename, "text/csv;charset=utf-8", "\uFEFF");
        return { success: true, exported: true };
      }
    },
    async GetStatusDetails(_, payload) {
      var params =
        "uname=" +
        payload.agent +
        "&status=" +
        payload.agentStatus +
        "&from=" +
        payload.from +
        "&to=" +
        payload.to +
        "&offset=" +
        payload.offset +
        "&limit=" +
        payload.limit +
        "&iscount=" +
        payload.iscount +
        "&export=" +
        payload.export;

      const response = await auth.middleware.get(
        "/UsersStatusReport?" + params,
        {
          headers: { request: "UsersStatusReport" },
        }
      );

      const responseData = response.data;
      if (response.status !== 200) {
        return { success: responseData.success, message: responseData.message };
        //   const error = new Error(responseData.message || "Failed to get users");
        //   throw error;
      }
      //
      if (!payload.export) {
        return {
          success: responseData.success,
          message: responseData.message,
          records: responseData.result.records,
          count: responseData.result.count,
        };
      } else {
        var filename = "users_status_report_" + moment().unix() + ".csv";
        fileDownload(responseData, filename, "text/csv;charset=utf-8", "\uFEFF");
        return { success: true, exported: true };
      }
    },
    async GetStatusSummary(_, payload) {
      var params =
        "uname=" +
        payload.agent +
        "&from=" +
        payload.from +
        "&to=" +
        payload.to +
        "&offset=" +
        payload.offset +
        "&limit=" +
        payload.limit +
        "&iscount=" +
        payload.iscount +
        "&export=" +
        payload.export;

      const response = await auth.middleware.get(
        "/UsersStatusSummaryReport?" + params,
        {
          headers: { request: "UsersStatusSummaryReport" },
        }
      );

      const responseData = response.data;
      if (response.status !== 200) {
        return { success: responseData.success, message: responseData.message };
        //   const error = new Error(responseData.message || "Failed to get users");
        //   throw error;
      }
      //
      if (!payload.export) {
        return {
          success: responseData.success,
          message: responseData.message,
          records: responseData.result.records,
          count: responseData.result.count,
        };
      } else {
        var filename =
          "users_status_summary_report_" + moment().unix() + ".csv";
          fileDownload(responseData, filename, "text/csv;charset=utf-8", "\uFEFF");
        return { success: true, exported: true };
      }
    },
    async GetMainSummary(_, payload) {
      var params =
        "from=" +
        payload.from +
        "&to=" +
        payload.to +
        (payload.skill && payload.skill !== 0 && payload.skill !== "0"
          ? "&queue=" + payload.skill
          : "");
      const response = await auth.middleware.get(
        "/GetMainSummaryStats?" + params,
        {
          headers: { request: "GetMainSummaryStats" },
        }
      );
      const responseData = response.data;
      if (response.status !== 200) {
        return { success: responseData.success, message: responseData.message };
      }
      return {
        success: responseData.success,
        message: responseData.message,
        summary: responseData.result,
      };
    },

    async GetMainTraffic() {
      var params = "from=&to=";

      const response = await auth.middleware.get(
        "/GetMainTrafficStats?" + params,
        {
          headers: { request: "GetMainTrafficStats" },
        }
      );

      const responseData = response.data;
      if (response.status !== 200) {
        return { success: responseData.success, message: responseData.message };
      }

      return {
        success: responseData.success,
        message: responseData.message,
        summary: responseData.result.summary,
      };
    },

    async GetRecordingFile(_, payload) {
      var params = "callid=" + payload.callid + "&time=" + payload.time;

      const response = await auth.middleware.get("/RecordingFile?" + params, {
        headers: { request: "Recording" },
        responseType: "blob",
      });

      const responseData = response.data;
      if (response.status !== 200) {
        return { success: responseData.success, message: responseData.message };
        //   const error = new Error(responseData.message || "Failed to get users");
        //   throw error;
      }
      //
      if (payload.download) {
        fileDownload(responseData, payload.recordingfile);
        return { success: true, exported: true };
      } else {
        return {
          success: true,
          recording: responseData,
        };
      }
    },
    async GetAgentsKPIs(_, payload) {
      var params =
        "&from=" +
        payload.from +
        "&to=" +
        payload.to +
        "&offset=" +
        payload.offset +
        "&limit=" +
        payload.limit +
        "&export=" +
        payload.export;

      const response = await auth.middleware.get(
        "/AgentKPIPerDayReport?" + params,
        {
          headers: { request: "AgentKPIPerDayReport" },
        }
      );

      const responseData = response.data;
      if (response.status !== 200) {
        return { success: responseData.success, message: responseData.message };
      }
      if (!payload.export) {
        return {
          success: responseData.success,
          message: responseData.message,
          records: responseData.result.records,
          count: responseData.result.count,
        };
      } else {
        var filename = "agents_kpi_report_" + moment().unix() + ".csv";
        fileDownload(responseData, filename, "text/csv;charset=utf-8", "\uFEFF");
        return { success: true, exported: true };
      }
    },
    async GetOmniConversations(_, payload) {
      var params =
        "agent=" +
        payload.agent +
        "&from=" +
        payload.from +
        "&to=" +
        payload.to +
        "&omni_type=" +
        payload.omni_type +
        "&customer=" +
        payload.customer;

      const response = await auth.middleware.get(
        "/OmniConversationReport?" + params,
        {
          headers: { request: "OmniConversationReport" },
        }
      );

      const responseData = response.data;
      if (response.status !== 200) {
        return { success: responseData.success, message: responseData.message };
        //   const error = new Error(responseData.message || "Failed to get users");
        //   throw error;
      }
      return {
        success: responseData.success,
        message: responseData.message,
        conversations: responseData.result.conversations,
      };
    },

    async GetReportOmniConversationMessages(_, payload) {
      const response = await auth.middleware.get(
        "/GetReportOmniConversationMessages",
        {
          params: {
            conversation_id: payload.conversation_id,
            offset: payload.offset,
            limit: payload.limit,
          },
          headers: { request: "GetReportOmniConversationMessages" },
        }
      );

      const responseData = response.data;
      if (response.status !== 200) {
        return {
          success: responseData.success,
          message: responseData.message,
        };
      } else if (responseData.errorcode) {
        return {
          success: responseData.success,
          message: responseData.message,
        };
      } else {
        return {
          success: true,
          message: "request done successfully",
          errorcode: 0,
          messages: responseData.result.messages,
        };
      }
    },
    async GetKPIStats(_, payload) {
      var params = "from=" + payload.from;

      const response = await auth.middleware.get("/GetKPIStats?" + params, {
        headers: { request: "GetKPIStats" },
      });

      const responseData = response.data;
      if (response.status !== 200) {
        return { success: responseData.success, message: responseData.message };
      }

      return {
        success: responseData.success,
        message: responseData.message,
        KPIs: responseData.result.KPIs,
      };
    },
    async GetAnsweredAbandonedStat(_, payload) {
      var params =
        "from=" +
        payload.from +
        "&to=" +
        payload.to +
        (payload.skill && payload.skill !== 0 && payload.skill !== "0"
          ? "&queue=" + payload.skill
          : "");

      const response = await auth.middleware.get(
        "/GetAnsweredAbandonedStat?" + params,
        {
          headers: { request: "GetAnsweredAbandonedStat" },
        }
      );

      const responseData = response.data;
      if (response.status !== 200) {
        return { success: responseData.success, message: responseData.message };
        //   const error = new Error(responseData.message || "Failed to get users");
        //   throw error;
      }
      return {
        success: responseData.success,
        message: responseData.message,
        periods: responseData.result.periods,
      };
    },

    async GetCallReasonsReport(_, payload) {
      let params =
        "from=" +
        payload.from +
        "&to=" +
        payload.to +
        "&reason=" +
        (payload.reason || 0) +
        "&export=" +
        (payload.export == 2 ? "2" : payload.export == true ? "1" : "0");

      const headers = { request: "CallsReasonsReport" };
      let response;

      if (payload.export) {
        response = await auth.middleware.get("/CallsReasonsReport?" + params, {
          headers: headers,
          responseType: "blob",
        });
      } else {
        response = await auth.middleware.get("/CallsReasonsReport?" + params, {
          headers: headers,
        });
      }

      const responseData = response.data;
      if (response.status !== 200) {
        return { success: responseData.success, message: responseData.message };
      }

      if (!payload.export) {
        // Transform the hierarchical API response to the component's expected format
        // Recursive function to process nested children at any depth
        // parentLevel: the level of the parent item (to ensure we only process direct children)
        // parentId: the id of the parent item (to verify parent-child relationship)
        const processChildren = (children, parentLevel = 0, parentId = null) => {
          if (!children || children.length === 0) {
            return [];
          }
          
          // Filter to only include direct children
          // 1. Check level: should be parentLevel + 1
          // 2. Check parentID: should match parentId (if both are available)
          const directChildren = children.filter(child => {
            let isDirectChild = true;
            
            // Check level if available
            if (child.level !== undefined) {
              isDirectChild = child.level === parentLevel + 1;
            }
            
            // Also verify parentID if both parentId and child.parentID are available
            if (parentId !== null && child.parentID !== undefined && child.parentID !== null) {
              isDirectChild = isDirectChild && (child.parentID === parentId);
            }
            
            return isDirectChild;
          });
          
          // Sort children by id
          const sortedChildren = [...directChildren].sort((a, b) => (a.id || 0) - (b.id || 0));
          
          return sortedChildren.map((child) => {
            const childLevel = child.level !== undefined ? child.level : parentLevel + 1;
            const childId = child.id;
            const processedChildren = processChildren(child.children || [], childLevel, childId);
            
            // Calculate count: if has children, sum their counts; otherwise use own count
            const count = processedChildren.length > 0
              ? processedChildren.reduce((sum, c) => sum + (c.count || 0), 0)
              : (child.count || 0);
            
            return {
              id: child.id,
              name: child.reason,
              count: count,
              children: processedChildren
            };
          });
        };
        
        const transformReasons = (reasons) => {
          const result = {};
          
          // Sort reasons by id
          const sortedReasons = [...reasons].sort((a, b) => (a.id || 0) - (b.id || 0));
          
          sortedReasons.forEach((category) => {
            if (category.level === 0) {
              const categoryName = category.reason;
              const categoryId = category.id;
              const subcategories = processChildren(category.children || [], 0, categoryId);
              
              // Calculate category total count (sum of all subcategories)
              const categoryCount = subcategories.reduce((sum, sub) => sum + (sub.count || 0), 0);
              
              result[categoryName] = {
                id: category.id,
                count: categoryCount,
                subcategories: subcategories
              };
            }
          });
          
          return result;
        };

        const apiReasons = responseData.result?.reasons || [];
        const transformedData = transformReasons(apiReasons);
        
        // Add notSelected count
        transformedData.notSelected = responseData.result?.no_reasons || 0;

        return {
          success: responseData.success,
          message: responseData.message,
          result: transformedData,
        };
      } else {
        const filename = "call_reasons_report_" + moment().unix() + ".csv";
        fileDownload(responseData, filename, "text/csv;charset=utf-8", "\uFEFF");
        return { success: true, exported: true };
      }
    },
    async GetIVRReport(_, payload) {
      // For single node export, use export=2; otherwise export=1 for full export, 0 for no export
      const exportValue = payload.export ? (payload.node ? "2" : "1") : "0";
      var params =
        "from=" +
        payload.from +
        "&to=" +
        payload.to +
        "&node=" +
        (payload.node || 0) +
        "&export=" +
        exportValue;
      
      // Handle export case - request as blob for file download
      if (payload.export) {
        const response = await auth.middleware.get("/IVRNodesReport?" + params, {
          headers: { request: "IVRNodesReport" },
          responseType: "blob",
        });
        
        if (response.status !== 200) {
          return { success: false, message: "Failed to export IVR report" };
        }
        
        const responseData = response.data;
        const filename = "ivr_report_node_" + (payload.node || 0) + "_" + moment().unix() + ".csv";
        fileDownload(responseData, filename, "text/csv;charset=utf-8", "\uFEFF");
        return { success: true, exported: true };
      }
      
      // Normal fetch case
      const response = await auth.middleware.get("/IVRNodesReport?" + params, {
        headers: { request: "IVRNodesReport" },
      });
      const responseData = response.data;
      if (response.status !== 200) {
        return { success: responseData.success, message: responseData.message };
      }
      return {
        success: responseData.success,
        message: responseData.message,
        result: responseData.result,
      };
    },
    async GetCSATReport(_, payload) {
      const response = await auth.middleware.get("/RatingsReport", {
        params: {
          from: payload.from,
          to: payload.to,
          type: payload.ratingType,
        },
      });

      const responseData = response.data;
      if (response.status !== 200) {
        return { success: responseData.success, message: responseData.message };
      }

      return {
        success: responseData.success,
        message: responseData.message,
        ratings: responseData.result.rating,
      };
    },
    async GetRatingPerAgentReport(_, payload) {
      // Handle export case
      if (payload.export) {
        const response = await auth.middleware.get("/RatingPerAgentReport", {
          params: {
            from: payload.from,
            to: payload.to,
            export: 1,
          },
          headers: { request: "RatingPerAgentReport" },
          responseType: "blob",
        });

        if (response.status !== 200) {
          return { success: false, message: "Failed to export report" };
        }

        const filename = "csat_per_agent_report_" + moment().unix() + ".xlsx";
        fileDownload(response.data, filename, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
        return { success: true, exported: true };
      }

      const response = await auth.middleware.get("/RatingPerAgentReport", {
        params: {
          from: payload.from,
          to: payload.to,
          export: 0,
        },
        headers: { request: "RatingPerAgentReport" },
      });

      const responseData = response.data;
      if (response.status !== 200) {
        return { success: responseData.success, message: responseData.message };
      }

      return {
        success: responseData.success,
        message: responseData.message,
        result: responseData.result,
      };
    },
    async GetRatingPerMonthReport(_, payload) {
      // Handle export case
      if (payload.export) {
        const response = await auth.middleware.get("/RatingPerMonthReport", {
          params: {
            from: payload.from,
            to: payload.to,
            export: 1,
          },
          headers: { request: "RatingPerMonthReport" },
          responseType: "blob",
        });

        if (response.status !== 200) {
          return { success: false, message: "Failed to export report" };
        }

        const filename = "csat_per_month_report_" + moment().unix() + ".xlsx";
        fileDownload(response.data, filename, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
        return { success: true, exported: true };
      }

      const response = await auth.middleware.get("/RatingPerMonthReport", {
        params: {
          from: payload.from,
          to: payload.to,
          export: 0,
        },
        headers: { request: "RatingPerMonthReport" },
      });

      const responseData = response.data;
      if (response.status !== 200) {
        return { success: responseData.success, message: responseData.message };
      }

      return {
        success: responseData.success,
        message: responseData.message,
        result: responseData.result,
      };
    },
    async GetRatingPerCallReport(_, payload) {
      // Handle export case
      if (payload.export) {
        const response = await auth.middleware.get("/RatingPerCallReport", {
          params: {
            from: payload.from,
            to: payload.to,
            export: 1,
          },
          headers: { request: "RatingPerCallReport" },
          responseType: "blob",
        });

        if (response.status !== 200) {
          return { success: false, message: "Failed to export report" };
        }

        const filename = "csat_per_call_report_" + moment().unix() + ".xlsx";
        fileDownload(response.data, filename, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
        return { success: true, exported: true };
      }

      const response = await auth.middleware.get("/RatingPerCallReport", {
        params: {
          from: payload.from,
          to: payload.to,
          export: 0,
        },
        headers: { request: "RatingPerCallReport" },
      });

      const responseData = response.data;
      if (response.status !== 200) {
        return { success: responseData.success, message: responseData.message };
      }

      return {
        success: responseData.success,
        message: responseData.message,
        result: responseData.result,
      };
    },
    async GetCSATTableReport({ dispatch }, payload) {
      // Determine which endpoint to call based on reportVariant
      const variant = payload.reportVariant || 'per-agent';

      switch (variant) {
        case 'per-agent':
          return dispatch('GetRatingPerAgentReport', payload);
        case 'per-month':
          return dispatch('GetRatingPerMonthReport', payload);
        case 'per-call':
          return dispatch('GetRatingPerCallReport', payload);
        default:
          return dispatch('GetRatingPerAgentReport', payload);
      }
    },
    // ===== AI Integration: Call Analysis (transcription / QA / summary / sentiment) =====
    async GetCallAnalysisDetails(_, payload) {
      const callId = payload.call_id ?? payload.callId ?? "";
      const params = "call_id=" + encodeURIComponent(callId);

      const response = await auth.middleware.get(
        "/GetCallAnalysisDetails?" + params,
        { headers: { request: "GetCallAnalysisDetails" } }
      );

      const responseData = response.data;
      if (response.status !== 200) {
        return { success: false, message: responseData?.message };
      }

      return {
        success: responseData.success !== false,
        message: responseData.message,
        result: responseData.result ?? responseData ?? {},
      };
    },
    async GetCallAnalysisList(_, payload) {
      const limit = payload.limit || 10;
      const offset = payload.offset || 0;
      let params =
        "from=" + payload.from + "&to=" + payload.to +
        "&limit=" + limit + "&offset=" + offset;
      if (payload.sentiment_score != null && payload.sentiment_score !== "")
        params += "&sentiment_score=" + payload.sentiment_score;
      if (payload.qa_score != null && payload.qa_score !== "")
        params += "&qa_score=" + payload.qa_score;

      const response = await auth.middleware.get(
        "/GetCallAnalysisList?" + params,
        { headers: { request: "GetCallAnalysisList" } }
      );

      const responseData = response.data;
      if (response.status !== 200) {
        return { success: false, message: responseData?.message };
      }

      const result = responseData.result || responseData;
      const items =
        result.data || result.items || result.records || result.calls || result.analysis || [];
      const totalCount = result.pagination?.total_count ?? result.count ?? items.length;

      return {
        success: responseData.success !== false,
        message: responseData.message,
        items,
        count: totalCount,
        pagination: result.pagination || null,
      };
    },

    // ===== AI Integration: Voice Agent CDRs =====
    // The list endpoint does not paginate server-side, so we request a large
    // page and render all rows within the chosen date range (report is
    // configured as non-paginated).
    async GetVoiceCDRList(_, payload) {
      // Report is non-paginated; the framework sends the default page size (10),
      // so request a generous page to fetch all rows within the date range.
      const limit = Math.max(Number(payload.limit) || 0, 1000);
      const offset = payload.offset || 0;
      let params =
        "from=" + payload.from + "&to=" + payload.to +
        "&limit=" + limit + "&offset=" + offset;
      if (payload.caller_number)
        params += "&caller_number=" + encodeURIComponent(payload.caller_number);
      if (payload.min_duration != null && payload.min_duration !== "")
        params += "&min_duration=" + payload.min_duration;
      if (payload.max_duration != null && payload.max_duration !== "")
        params += "&max_duration=" + payload.max_duration;

      const response = await auth.middleware.get(
        "/GetListVoiceCDRs?" + params,
        { headers: { request: "GetListVoiceCDRs" } }
      );

      const responseData = response.data;
      if (response.status !== 200) {
        return { success: false, message: responseData?.message };
      }

      const result = responseData.result || responseData;
      const items =
        result.data || result.items || result.records || result.cdrs || result.calls || [];
      const totalCount = result.pagination?.total_count ?? result.count ?? items.length;

      return {
        success: responseData.success !== false,
        message: responseData.message,
        items,
        count: totalCount,
        pagination: result.pagination || null,
      };
    },
    async GetVoiceCDRStats(_, payload) {
      const params = "from=" + payload.from + "&to=" + payload.to;
      const response = await auth.middleware.get(
        "/GetVoiceCDRStats?" + params,
        { headers: { request: "GetVoiceCDRStats" } }
      );
      const responseData = response.data;
      if (response.status !== 200) {
        return { success: false, message: responseData?.message };
      }
      const result = responseData.result || responseData;
      return {
        success: responseData.success !== false,
        message: responseData.message,
        stats: result.stats || result.data || result || {},
      };
    },
    async GetVoiceCDRDetails(_, payload) {
      const callId = payload.call_id ?? payload.callId ?? "";
      const params = "call_id=" + encodeURIComponent(callId);

      const response = await auth.middleware.get(
        "/GetVoiceCDRDetails?" + params,
        { headers: { request: "GetVoiceCDRDetails" } }
      );

      const responseData = response.data;
      if (response.status !== 200) {
        return { success: false, message: responseData?.message };
      }

      return {
        success: responseData.success !== false,
        message: responseData.message,
        result: responseData.result ?? responseData ?? {},
      };
    },

    // Fetch the audio for a voice-agent call so the details page can play it.
    // NOTE (wire-later): voice (LiveKit) recordings come back from the CDR as a
    // server file path (recording_path), not a playable URL, and no streaming
    // endpoint is documented yet. Point the request below at the real endpoint
    // (adjust the path, query params and `request` header) once the backend
    // confirms it. Until then this returns { success: false } and the UI shows
    // a graceful "recording unavailable" message.
    async GetVoiceRecording(_, payload) {
      const callId = payload.call_id ?? payload.callId ?? "";
      const recordingPath = payload.recording_path ?? payload.recordingPath ?? "";
      let params = "call_id=" + encodeURIComponent(callId);
      if (recordingPath)
        params += "&recording_path=" + encodeURIComponent(recordingPath);

      let response;
      try {
        response = await auth.middleware.get("/GetVoiceRecording?" + params, {
          headers: { request: "VoiceRecording" },
          responseType: "blob",
        });
      } catch (err) {
        return { success: false, message: err.message || "Failed to load recording" };
      }

      if (response.status !== 200) {
        return { success: false, message: "Failed to load recording" };
      }

      // The endpoint may answer with a JSON error instead of audio bytes.
      const probe = await probeBlobForJson(response.data);
      if (probe.isJson) {
        return {
          success: false,
          message: probe.payload?.message || "Recording not available",
        };
      }

      return { success: true, recording: response.data };
    },

    // ===== AI Integration: Omnichannel AI Chat Transcripts =====
    // List endpoint is not paginated server-side; request all rows in range.
    async GetAIChatList(_, payload) {
      // Report is non-paginated; request a generous page to fetch all rows.
      const limit = Math.max(Number(payload.limit) || 0, 1000);
      const offset = payload.offset || 0;
      let params =
        "from=" + payload.from + "&to=" + payload.to +
        "&limit=" + limit + "&offset=" + offset;
      if (payload.channel != null && payload.channel !== "" && payload.channel !== 0)
        params += "&channel=" + payload.channel;
      if (payload.customer)
        params += "&customer=" + encodeURIComponent(payload.customer);
      if (payload.outcome != null && payload.outcome !== "")
        params += "&outcome=" + encodeURIComponent(payload.outcome);

      const response = await auth.middleware.get(
        "/GetOmnisChatList?" + params,
        { headers: { request: "GetOmnisChatList" } }
      );

      const responseData = response.data;
      if (response.status !== 200) {
        return { success: false, message: responseData?.message };
      }

      const result = responseData.result || responseData;
      const items =
        result.conversations || result.data || result.items || result.records || result.chats || [];
      const totalCount = result.pagination?.total_count ?? result.count ?? items.length;

      return {
        success: responseData.success !== false,
        message: responseData.message,
        items,
        count: totalCount,
        pagination: result.pagination || null,
      };
    },
    async GetAIChatStats(_, payload) {
      const params = "from=" + payload.from + "&to=" + payload.to;
      const response = await auth.middleware.get(
        "/GetOmniChatStats?" + params,
        { headers: { request: "GetOmniChatStats" } }
      );
      const responseData = response.data;
      if (response.status !== 200) {
        return { success: false, message: responseData?.message };
      }
      const result = responseData.result || responseData;
      return {
        success: responseData.success !== false,
        message: responseData.message,
        stats: result.data || result.stats || result || {},
      };
    },
    async GetAIChatDetails(_, payload) {
      const conversationId =
        payload.conversation_id ?? payload.conversationId ?? "";
      const params = "conversation_id=" + encodeURIComponent(conversationId);

      const response = await auth.middleware.get(
        "/GetOmniChatDetails?" + params,
        { headers: { request: "GetOmniChatDetails" } }
      );

      const responseData = response.data;
      if (response.status !== 200) {
        return { success: false, message: responseData?.message };
      }

      return {
        success: responseData.success !== false,
        message: responseData.message,
        result: responseData.result ?? responseData ?? {},
      };
    },
  },
  getters: {},
};
